import React, { useState, useEffect } from "react";
import {
  getFirestore, collectionGroup, collection, getDocs, deleteDoc, doc, query, where, orderBy, limit, startAfter, serverTimestamp, updateDoc
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { PAGES_META, getAccessiblePagesForUser } from "../constants/pagesMeta"; // <-- NEW (create this file)
import { getCountFromServer } from "firebase/firestore";
import * as XLSX from "xlsx";
import { sendEmailViaGmail } from "../utils/sendEmailViaGmail";
import SchoolPlanEditor, { schoolPlanSummary } from "../components/admin/SchoolPlanEditor";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [newVisitUserIds, setNewVisitUserIds] = useState([]);
  useEffect(() => {
    const ids = JSON.parse(localStorage.getItem("newVisitUserIds") || "[]");
    setNewVisitUserIds(ids);
  }, []);
  
  const [showDetails, setShowDetails] = useState(null); // selected user
  const [logs, setLogs] = useState([]);                 // <-- NEW
  const [logsCursor, setLogsCursor] = useState(null);   // <-- NEW
  const [logsLoading, setLogsLoading] = useState(false);// <-- NEW
  const [showViewsFor, setShowViewsFor] = useState(null); // user object we're viewing logs for
   const [viewsLoading, setViewsLoading] = useState(false);
   const [pageHits, setPageHits] = useState([]); // raw hits
   const [pageSummary, setPageSummary] = useState([]); // [{path, count, lastTs}]
  // ---- Daily Login Counter state ----
  //const [counterDate, setCounterDate] = useState(new Date()); // which day are we viewing
  //const [dailyCounts, setDailyCounts] = useState({ educators: 0, students: 0 });
  //const [dailyLoading, setDailyLoading] = useState(false);
  //const [dailyError, setDailyError] = useState("");
  const [expandedEducator, setExpandedEducator] = useState(null);
  const [showCounterPanel, setShowCounterPanel] = useState(false);
const [globalPageSummary, setGlobalPageSummary] = useState([]);
const [dashboardCounts, setDashboardCounts] = useState({}); // { [uid]: number }
const [recentVisits, setRecentVisits] = useState([]);
const [trialDraftDate, setTrialDraftDate] = useState("");
const [selectedUserIds, setSelectedUserIds] = useState([]);
// 🏫 School / District plan pop-up: { uids, current, label } or null
const [schoolPlanFor, setSchoolPlanFor] = useState(null);
const [showEmailModal, setShowEmailModal] = useState(false);
const [emailSubject, setEmailSubject] = useState("");
const [emailBody, setEmailBody] = useState("");
const [sendingEmail, setSendingEmail] = useState(false);

const [purchaseOrders, setPurchaseOrders] = useState([]);

function toggleSelectUser(userId) {
  setSelectedUserIds((prev) => {
    if (prev.includes(userId)) {
      return prev.filter((id) => id !== userId); // unselect
    }
    return [...prev, userId]; // select
  });
}


// INSERT: sorting state + helpers
const [sortConfig, setSortConfig] = useState({ key: null, dir: "asc" }); // dir: 'asc' | 'desc'

// 🔍 SEARCH STATE
const [searchTerm, setSearchTerm] = useState("");

// normalize string safely
const norm = (v) => (v || "").toString().toLowerCase().trim();

// apply search across allowed fields
const filteredUsers = React.useMemo(() => {
  if (!searchTerm) return users;

  const q = norm(searchTerm);

  return users.filter((u) =>
    norm(u.firstName).includes(q) ||
    norm(u.lastName).includes(q) ||
    norm(u.schoolName).includes(q) ||
    norm(u.schoolDistrict).includes(q) ||
    norm(u.email).includes(q) ||
    norm(u.educatorCode).includes(q)
  );
}, [users, searchTerm]);


// Normalize values per column (so sorting is clean)
function getSortableValue(user, key) {
  const v = user?.[key];

  // special handling for grade natural order
  if (key === "grade") {
    const order = { "1st": 1, "2nd": 2, "3rd": 3, "4th": 4, "5th": 5 };
    return order[v] ?? Number.MAX_SAFE_INTEGER;
  }

  // timestamps (if you ever add createdAt to table later)
  if (v?.toDate) return v.toDate().getTime();

  // numbers
  if (typeof v === "number") return v;

  // strings default to lowercase comparison
  if (typeof v === "string") return v.toLowerCase();

  // fallback
  return v ?? "";
}

function sortArray(arr, key, dir) {
  if (!key) return arr;
  const mul = dir === "asc" ? 1 : -1;
  return [...arr].sort((a, b) => {
    const A = getSortableValue(a, key);
    const B = getSortableValue(b, key);
    if (A < B) return -1 * mul;
    if (A > B) return 1 * mul;
    return 0;
  });
}

function handleSort(key) {
  setSortConfig((prev) =>
    prev.key === key
      ? { key, dir: prev.dir === "asc" ? "desc" : "asc" }
      : { key, dir: "asc" }
  );
}

// a tiny header control so you don't repeat yourself
function SortHeader({ label, colKey }) {
  const isActive = sortConfig.key === colKey;
  const arrow = !isActive ? "⇅" : sortConfig.dir === "asc" ? "↑" : "↓";
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span>{label}</span>
      <button
        type="button"
        onClick={() => handleSort(colKey)}
        title={`Sort by ${label}`}
        style={{
          border: "1px solid #ddd",
          padding: "2px 6px",
          background: isActive ? "#eef2ff" : "#fff",
          borderRadius: 6,
          cursor: "pointer",
          fontSize: 12,
          lineHeight: 1,
        }}
      >
        {arrow}
      </button>
    </div>
  );
}

  const db = getFirestore();
  const navigate = useNavigate();

  
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersCollection = collection(db, "users");
        const snapshot = await getDocs(usersCollection);
        const userList = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setUsers(userList);
      } catch (error) {
        console.error("Error fetching users:", error.message);
      }
    };
    fetchUsers();
  }, [db]);
  
  const handleDelete = async (userId) => {
    const user = users.find(u => u.id === userId);
  
    const isTeacher = (user.role || "").toLowerCase().includes("educator");
    const educatorCode = user.educatorCode;
  
    let studentsToDelete = [];
  
    if (isTeacher && educatorCode) {
      studentsToDelete = users.filter(
        u =>
          u.educatorCode === educatorCode &&
          (u.role || "").toLowerCase().includes("student")
      );
    }
  
    const totalCount = 1 + studentsToDelete.length;
  
    const confirmDelete = window.confirm(
      `Delete ${user.firstName} ${user.lastName}?` +
        (isTeacher && studentsToDelete.length > 0
          ? `\n\n⚠️ This educator has ${studentsToDelete.length} student(s) assigned.\n` +
            `Those students WILL also be deleted.\n`
          : "") +
        `\nTotal users to delete: ${totalCount}\n\n` +
        `This action cannot be undone.`
    );
  
    if (!confirmDelete) return;
  
    try {
      // Delete main user + students
      const idsToDelete = [userId, ...studentsToDelete.map(s => s.id)];
  
      await Promise.all(
        idsToDelete.map(id => deleteDoc(doc(db, "users", id)))
      );
  
      setUsers(prev => prev.filter(u => !idsToDelete.includes(u.id)));
  
      alert(`Deleted ${totalCount} user(s).`);
    } catch (error) {
      console.error("Error deleting user(s):", error.message);
      alert("Failed to delete. Check console.");
    }
  };
  function getAccessActionLabel(user) {
    if (user?.subscription?.status === "paid") return "Suspend Access";
  
    if (isTrialExpiredByDate(user)) return "Restore Trial";
  
    if (user?.trial?.status === "paused") return "Resume Access";
  
    return "Pause Access";
  }
   
  useEffect(() => {
    const loadPOs = async () => {
      const snap = await getDocs(collection(db, "purchaseOrders"));
      setPurchaseOrders(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    loadPOs();
  }, [db]);
  
  async function approvePO(po) {
    const ok = window.confirm(
      `Approve PO for ${po.schoolName} ($${po.price}) and mark as PAID?`
    );
    if (!ok) return;
  
    // 1️⃣ Mark PO approved
    await updateDoc(doc(db, "purchaseOrders", po.id), {
      status: "paid",
      approvedAt: serverTimestamp(),
    });
  
    // 2️⃣ Upgrade educator account
    await updateDoc(doc(db, "users", po.userId), {
      subscription: {
        status: "paid",
        source: "purchase_order",
        tier: po.studentTier,
        price: po.price,
        updatedAt: serverTimestamp(),
      },
      "trial.status": "inactive",
    });
  
    alert("PO approved & account activated.");
  }
  
  function renderStatusBadge(user) {
    const expiredByDate = isTrialExpiredByDate(user);
    const trialStatus = expiredByDate ? "expired" : user?.trial?.status;
    const subStatus = user?.subscription?.status;
  
    let label = "Trial";
    let bg = "#e5e7eb";
    let color = "#111";
  
    if (subStatus === "paid") {
      label = "Paid";
      bg = "#dcfce7";
      color = "#166534";
    } else if (trialStatus === "expired") {
      label = "Trial Expired";
      bg = "#fee2e2";
      color = "#991b1b";
    } else if (trialStatus === "paused") {
      label = "Paused";
      bg = "#fef3c7";
      color = "#92400e";
    }
  
    return (
      <span
        style={{
          padding: "4px 10px",
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 700,
          background: bg,
          color,
          border: "1px solid rgba(0,0,0,.1)",
        }}
      >
        {label}
      </span>
    );
  }
  function isTrialExpiredByDate(user) {
    const end = user?.trial?.endDate;
    if (!end) return false;
  
    const endDate = end?.toDate ? end.toDate() : new Date(end);
    return endDate.getTime() < Date.now();
  }  
  
  const handleBulkDelete = async () => {
    if (selectedUserIds.length === 0) return;
  
    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${selectedUserIds.length} user(s)?\n\n` +
      `This action cannot be undone.`
    );
  
    if (!confirmDelete) return;
  
    try {
      await Promise.all(
        selectedUserIds.map(id => deleteDoc(doc(db, "users", id)))
      );
  
      setUsers(prev => prev.filter(u => !selectedUserIds.includes(u.id)));
      setSelectedUserIds([]);
  
      alert("Selected users deleted successfully.");
    } catch (err) {
      console.error("Bulk delete failed:", err);
      alert("Error deleting users.");
    }
  };

  const handleBulkRestoreAccess = async () => {
    if (selectedUserIds.length === 0) return;
  
    const ok = window.confirm(
      `Restore access for ${selectedUserIds.length} user(s)?`
    );
    if (!ok) return;
  
    try {
      await Promise.all(
        selectedUserIds.map((id) =>
          updateDoc(doc(db, "users", id), {
            "trial.status": "active",
            "trial.updatedAt": serverTimestamp(),
          })
        )
      );
  
      setUsers((prev) =>
        prev.map((u) =>
          selectedUserIds.includes(u.id)
            ? { ...u, trial: { ...(u.trial || {}), status: "active" } }
            : u
        )
      );
  
      setSelectedUserIds([]);
      alert("Access restored.");
    } catch (e) {
      console.error("Bulk restore failed", e);
      alert("Failed to restore access.");
    }
  };
  
  async function setTrialStatus(userId, status) {
    const ok = window.confirm(`Set user status to "${status}"?`);
    if (!ok) return;
  
    await updateDoc(doc(db, "users", userId), {
      "trial.status": status,
      "trial.updatedAt": serverTimestamp(),
    });
  
    setUsers(prev =>
      prev.map(u =>
        u.id === userId
          ? { ...u, trial: { ...(u.trial || {}), status } }
          : u
      )
    );
  }
  
  const handlePause = async (userId) => {
    const user = users.find(u => u.id === userId);
    if (!user) return;
  
    const currentStatus = user?.trial?.status || "active";
  
    let nextStatus;
    let confirmMsg;
  
    if (currentStatus === "active") {
      nextStatus = "paused";
      confirmMsg = "Pause this educator’s access?";
    } else {
      nextStatus = "active";
      confirmMsg = "Restore this educator’s access?";
    }
  
    const ok = window.confirm(confirmMsg);
    if (!ok) return;
  
    try {
      await updateDoc(doc(db, "users", userId), {
        "trial.status": nextStatus,
        "trial.updatedAt": serverTimestamp(),
      });
  
      // update local UI state so table refreshes instantly
      setUsers(prev =>
        prev.map(u =>
          u.id === userId
            ? { ...u, trial: { ...(u.trial || {}), status: nextStatus } }
            : u
        )
      );
  
    } catch (e) {
      console.error("Failed to toggle access:", e);
      alert("Failed to update user access.");
    }
  };
  

  const formatDateMaybe = (v) => {
    if (!v) return "";
    if (v?.toDate) return v.toDate().toLocaleString();
    try { return new Date(v).toLocaleString(); } catch { return ""; }
  };

  function formatTrialEnd(user) {
    const d = user?.trial?.endDate;
    if (!d) return "—";
    try {
      return d.toDate().toLocaleDateString();
    } catch {
      return "—";
    }
  }
  
  useEffect(() => {
    if (!showDetails) return;
  
    const d = showDetails?.trial?.endDate;
    if (!d) return setTrialDraftDate("");
  
    const jsDate = d?.toDate ? d.toDate() : new Date(d);
    setTrialDraftDate(jsDate.toISOString().slice(0, 10));
  }, [showDetails]);
  
  
  // --- NEW: load first page of logs for a user
  const loadLogs = async (userId, after = null) => {
    setLogsLoading(true);
    try {
      const ref = collectionGroup(db, "pageLogs"); // ✅ matches users/{uid}/pageLogs with your rules
      let qRef = query(ref, where("userId", "==", userId), orderBy("ts", "desc"), limit(50));
      if (after) {
        qRef = query(ref, where("userId", "==", userId), orderBy("ts", "desc"), startAfter(after), limit(50));
      }
      const snap = await getDocs(qRef);
      const rows = snap.docs.map(d => ({ id: d.id, ...d.data(), _snap: d }));
      setLogs(after ? (prev) => [...prev, ...rows] : rows);
      setLogsCursor(snap.docs[snap.docs.length - 1] || null);
    } catch (e) {
      console.error("loadLogs error:", e);
    } finally {
      setLogsLoading(false);
    }
  };

    // start/end of day (local time)
   // function startOfDay(d) {
    //  const x = new Date(d);
    //  x.setHours(0, 0, 0, 0);
    //  return x;
   // }
   // function endOfDay(d) {
   //   const x = new Date(d);
   //   x.setHours(23, 59, 59, 999);
   //   return x;
   // }
  
    // Load unique daily counts for educators & students based on pageLogs
    //const loadDailyLoginCounts = async (day) => {
    //  setDailyLoading(true);
   //  setDailyError("");
    //  try {
    //    const start = startOfDay(day);
     //   const end = endOfDay(day);
  
        // Grab all logs in the day range (across all users)
      //  const ref = collectionGroup(db, "pageLogs");
      //  const qRef = query(
      //    ref,
      //    where("ts", ">=", start),
     //     where("ts", "<=", end),
     //     limit(5000) // adjust if you expect >5k hits/day; otherwise paginate
     //   );
     //   const snap = await getDocs(qRef);
  
     //   const eduUsers = new Set();
     //   const stuUsers = new Set();
  
      //  snap.forEach((doc) => {
      //    const d = doc.data() || {};
      //    const uid = d.userId;
      //    const path = (d.path || "").toLowerCase();
  
      //    if (!uid) return;
  
          // classify by path prefix
       //   if (path.startsWith("/educator")) eduUsers.add(uid);
     //     if (path.startsWith("/student"))  stuUsers.add(uid);
     //   });
  
   //     setDailyCounts({ educators: eduUsers.size, students: stuUsers.size });
   //   } catch (e) {
   //     console.error("daily counter error:", e);
   //     setDailyError("Failed to load daily counts");
   //   } finally {
   //     setDailyLoading(false);
   //   }
  //  };
  
   // useEffect(() => {
    //  loadDailyLoginCounts(counterDate);
  //  }, [counterDate]);
  
    // NEW: Load full summary for all users combined
    const EXPECTED_PATHS = [
      "/educator/dashboard",
      "/educator/classroom",
      "/educator/math",
      "/educator/science",
      "/educator/socialstudies",
      "/educator/other",
      "/dashboard",
      "/student/math",
      "/student/science",
      "/student/socialstudies",
      "/student/other",
    ];
    
    // Fallback: read each user's subcollection and aggregate (mirrors your View modal, so it's guaranteed to work with your current rules)
    async function aggregateFromUsersSubcollections(db, users) {
      const map = new Map(); // key: path (lower), val: { path, count }
      // pre-seed with expected paths
      for (const p of EXPECTED_PATHS) {
        map.set(p.toLowerCase(), { path: p.toLowerCase(), count: 0 });
      }
    
      // NOTE: adjust per-user limit if you want deeper history than 200
      const perUserLimit = 200;
    
      await Promise.all(
        users.map(async (u) => {
          try {
            const ref = collection(db, "users", u.id, "pageLogs");
            const snap = await getDocs(query(ref, orderBy("ts", "desc"), limit(perUserLimit)));
            snap.forEach((d) => {
              const x = d.data() || {};
              const raw = (x.path || "").trim();
              if (!raw) return;
              const key = raw.toLowerCase();
              if (!map.has(key)) map.set(key, { path: key, count: 0 });
              map.get(key).count += 1;
            });
          } catch (e) {
            console.error("aggregateFromUsersSubcollections error for", u.id, e);
          }
        })
      );
    
      const arr = Array.from(map.values()).sort((a, b) => b.count - a.count);
      return arr;
    }
    
    // After users are fetched, compute each user's dashboard visit count
// useEffect(() => {
 // if (!users || users.length === 0) return;
//  users.forEach((u) => fetchDashboardCountForUser(u));
  // It's OK if this runs again when users changes — updates are idempotent.
// }, [users]);

    const loadGlobalSummary = async () => {
     // setDailyLoading(true);
      try {
        // --- Fast path: cheap aggregated counts per EXPECTED_PATHS using collectionGroup + where(path, '==', ...)
        const ref = collectionGroup(db, "pageLogs");
    
        const lower = (s) => s.toLowerCase();
        const counts = await Promise.all(
          EXPECTED_PATHS.map(async (p) => {
            try {
              // count docs where path equals this expected path (case-insensitive match by normalizing what you write to logs)
              const c = await getCountFromServer(query(ref, where("path", "==", p)));
              return { path: lower(p), count: c.data().count || 0 };
            } catch (e) {
              console.warn("getCountFromServer failed for", p, e);
              return { path: lower(p), count: 0 };
            }
          })
        );
    
        let arr = counts.sort((a, b) => b.count - a.count);
    
        // If all zeros, your rules are likely blocking collection-group reads.
        // Fallback to per-user subcollection aggregation (works because your View modal already can read those).
        const total = arr.reduce((sum, r) => sum + r.count, 0);
        if (total === 0) {
          console.info("Collection-group counts returned 0; falling back to per-user aggregation.");
          arr = await aggregateFromUsersSubcollections(db, users);
        }
    
        setGlobalPageSummary(arr);
      } catch (err) {
        console.error("loadGlobalSummary error", err);
        // As a final fallback, try per-user aggregation so the UI shows *something*.
        try {
          const arr = await aggregateFromUsersSubcollections(db, users);
          setGlobalPageSummary(arr);
        } catch (e) {
          console.error("fallback aggregateFromUsersSubcollections error", e);
          setGlobalPageSummary([]);
        }
      } finally {
    //    setDailyLoading(false);
      }
    };
    
    


// Build expected *paths* for a role like "va-1st-educator" or "va-1st-student" or "administrator"
function expectedPathsForRole(role = "") {
  const r = (role || "").toLowerCase().trim();

  // --- Admins: dashboards + admin pages (plus you can add more)
  if (r === "administrator" || r === "admin") {
    return [
      // admin dashboards
      "/admin",
      "/admin/users",
      "/admin/roles",
      "/admin/tools",
      "/admin/settings",

      // educator & student dashboards (admins can visit these too)
      "/educator/dashboard",
      "/dashboard",
    ];
  }

  // educator vs student?
  const m = r.match(/^([a-z]{2})-(\d)(st|nd|rd|th)-(educator|student)$/);
  if (!m) return [];

  const [, state, gradeNum, , kind] = m; // ex: "va", "1", "", "educator"
  const grade =
    gradeNum === "1" ? "1st" :
    gradeNum === "2" ? "2nd" :
    gradeNum === "3" ? "3rd" : `${gradeNum}th`;

  // Common: dashboards for each kind
  const base = kind === "educator"
    ? ["/educator/dashboard"]
    : ["/dashboard"];

  // Subject slugs we care about
  const eduSubjects = ["classroom", "math", "science", "socialstudies", "other"];
  const stuSubjects = ["math", "science", "socialstudies", "other"];

  // Your route patterns from App.jsx look like:
  //  Educator content: /educator/{state}/{state}-{grade}-educator-{subject}
  //  Student content : /student/{state}/{state}-{grade}-student-{subject}
  if (kind === "educator") {
    const content = eduSubjects.map(
      (s) => `/educator/${state}/${state}-${grade}-educator-${s}`
    );
    return [...base, ...content];
  } else {
    const content = stuSubjects.map(
      (s) => `/student/${state}/${state}-${grade}-student-${s}`
    );
    return [...base, ...content];
  }
}

// 📤 EXPORT USERS TO EXCEL (respects search)
const exportUsersToExcel = () => {
  const rows = filteredUsers.map((u) => ({
    "First Name": u.firstName || "",
    "Last Name": u.lastName || "",
    "Email": u.email || "",
    "Role": u.role || "",
    "View": u.view || "",                // ✅ ADD THIS LINE
    "Educator Code": u.educatorCode || "",
    "School Name": u.schoolName || "",
    "School District": u.schoolDistrict || "",
    "State": u.state || "",
    "Grade": u.grade || "",
    "Dashboard Visits": dashboardCounts[u.id] ?? 0,
    "UID": u.id,
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  XLSX.writeFile(workbook, "users_export.xlsx");
};

async function openViewsModalForUser(db, user) {
  const existing = JSON.parse(localStorage.getItem("newVisitUserIds") || "[]");
  const updated = existing.filter((id) => id !== user.id);
  localStorage.setItem("newVisitUserIds", JSON.stringify(updated));
  setNewVisitUserIds(updated);
  setShowViewsFor(user);
  setViewsLoading(true);
  try {
    // read most recent 200 hits from subcollection users/{uid}/pageLogs
    const ref = collection(db, "users", user.id, "pageLogs");
    const snap = await getDocs(query(ref, orderBy("ts", "desc"), limit(200)));
    const rows = snap.docs.map((d) => {
      const x = d.data();
      return {
        id: d.id,
        path: x.path || "",
        title: x.title || "",
        referrer: x.referrer || "",
        device: x.device || "",
        ip: x.ip || "",              // ✅ include IP if your logs ever have it
        ts: x.ts || null,
      };
    });
    setPageHits(rows);

    // ✅ Summarize hits per path (Dashboard, Classroom, Math, etc.)
    const map = new Map();

    // 1. Count actual log entries
    for (const r of rows) {
      const path = r.path || "(unknown)";
      const cleanPath = path.toLowerCase();
      if (!map.has(cleanPath)) map.set(cleanPath, { path, count: 0, lastTs: null });
      const s = map.get(cleanPath);
      s.count += 1;
      const ts = r.ts?.toMillis ? r.ts.toMillis() : (r.ts ? new Date(r.ts).getTime() : 0);
      const prev = s.lastTs?.toMillis ? s.lastTs.toMillis() : (s.lastTs ? new Date(s.lastTs).getTime() : 0);
      if (ts > prev) s.lastTs = r.ts;
    }

    // 2. Add default pages so zero-visit ones still appear
    const expected = [
      "/educator/dashboard",
      "/educator/classroom",
      "/educator/math",
      "/educator/science",
      "/educator/socialstudies",
      "/educator/other",
      "/dashboard",
      "/student/math",
      "/student/science",
      "/student/socialstudies",
      "/student/other"
    ];
    for (const p of expected) {
      if (!map.has(p)) {
        map.set(p, { path: p, count: 0, lastTs: null });
      }
    }

    // 3. Sort by most visits, then latest timestamp
    const summary = Array.from(map.values()).sort(
      (a, b) => (b.count - a.count) || ((b.lastTs?.toMillis?.() || 0) - (a.lastTs?.toMillis?.() || 0))
    );
    setPageSummary(summary);
  } finally {
    setViewsLoading(false);
  }
}


// --- FIXED SORTING (before you render the grouped users)
const sortedUsers = React.useMemo(() => {
  const key = sortConfig.key;
  const dir = sortConfig.dir === "asc" ? 1 : -1;

  if (!key) return [...users];

  return [...users].sort((a, b) => {
    const A =
      key === "dashboardVisits"
        ? (dashboardCounts[a.id] ?? 0)
        : getSortableValue(a, key);
    const B =
      key === "dashboardVisits"
        ? (dashboardCounts[b.id] ?? 0)
        : getSortableValue(b, key);

    if (A < B) return -1 * dir;
    if (A > B) return 1 * dir;
    return 0;
  });
}, [users, sortConfig, dashboardCounts]);


function SortBtn({ colKey }) {
  const isActive = sortConfig.key === colKey;
  const glyph = !isActive ? "⇅" : (sortConfig.dir === "asc" ? "↑" : "↓");
  return (
    <button
      type="button"
      onClick={() => handleSort(colKey)}
      title={`Sort by ${colKey}`}
      style={{
        marginLeft: 6,
        border: "1px solid #ddd",
        background: isActive ? "#eef2ff" : "#fff",
        borderRadius: 6,
        padding: "2px 6px",
        cursor: "pointer",
        fontSize: 12,
        lineHeight: 1,
      }}
    >
      {glyph}
    </button>
  );
}

async function loadRecentPageVisits() {
  try {
    const ref = collection(db, "pageVisits");
    const snap = await getDocs(query(ref, orderBy("ts", "desc"), limit(200)));
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setRecentVisits(list);
  } catch (e) {
    console.error("Could not load pageVisits:", e);
  }
}

// Count dashboard hits for a specific user using their own subcollection
async function fetchDashboardCountForUser(u) {
  if (!u?.id) return;

  // Which path is the dashboard for this role?
  const isEdu = (u.role || "").toLowerCase().includes("educator");
  const dashPath = isEdu ? "/educator/dashboard" : "/dashboard";

  try {
    // Fast count
    const sub = collection(db, "users", u.id, "pageLogs");
    const c = await getCountFromServer(query(sub, where("path", "==", dashPath)));
    const n = c.data().count || 0;
    setDashboardCounts(prev => ({ ...prev, [u.id]: n }));
  } catch (e) {
    console.warn("getCountFromServer failed for", u.id, e);
    // Fallback: manual read
    const sub = collection(db, "users", u.id, "pageLogs");
    const snap = await getDocs(query(sub, where("path", "==", dashPath)));
    setDashboardCounts(prev => ({ ...prev, [u.id]: snap.size }));
  }
}

  return (
   <div style={{ padding: "20px", textAlign: "center" }}>
          {/* Daily Login Counter (fixed top-right) */}
          {/* Global Page Summary Counter (toggleable) */}
{/* Global Page Summary Counter (toggleable) */}
<div
  style={{
    position: "fixed",
    top: 12,
    right: 12,
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "10px 12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.10)",
    zIndex: 1100,
    minWidth: 260,
  }}
>
<button
  onClick={() => {
    if (!showCounterPanel) loadRecentPageVisits();
    setShowCounterPanel(v => !v);
  }}
  style={{
    width: "100%",
    border: "1px solid #ccc",
    background: showCounterPanel ? "#2563eb" : "#fff",
    color: showCounterPanel ? "#fff" : "#000",
    borderRadius: 8,
    padding: "6px 10px",
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: 6,
  }}
>
  {showCounterPanel ? "Hide Page Notifications" : "Show Page Notifications"}
</button>

{showCounterPanel && (
  <div style={{ maxHeight: 350, overflowY: "auto", fontSize: 12 }}>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={styles.th}>Name</th>
          <th style={styles.th}>School</th>
          <th style={styles.th}>Page</th>
          <th style={styles.th}>When</th>
        </tr>
      </thead>

      <tbody>
        {recentVisits.map(v => (
          <tr key={v.id}>
            <td style={styles.td}>
              {v.firstName} {v.lastName}
            </td>
            <td style={styles.td}>{v.schoolName}</td>
            <td style={styles.td}><code>{v.path}</code></td>
            <td style={styles.td}>{formatDateMaybe(v.ts)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

</div>

      <button onClick={() => navigate("/admin")} style={styles.returnButton}>
        Return to Admin Dashboard
      </button>

      <h1>Manage Users</h1>
{/* 📧 Email Actions */}
<div
  style={{
    display: "flex",
    gap: 10,
    justifyContent: "center",
    marginBottom: 20,
    flexWrap: "wrap",
  }}
>
  <button
    style={{
      padding: "8px 14px",
      background: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      cursor: "pointer",
      fontWeight: 600,
    }}
    disabled={selectedUserIds.length === 0}
    onClick={() => setShowEmailModal(true)}
  >
    📧 Email Selected Users ({selectedUserIds.length})
  </button>
</div>

      <h2>Pending Purchase Orders</h2>

<table style={styles.table}>
  <thead>
    <tr>
      <th>School</th>
      <th>Educator</th>
      <th>Tier</th>
      <th>Price</th>
      <th>PO</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {purchaseOrders
      .filter(po => po.status === "pending")
      .map(po => (
        <tr key={po.id}>
          <td>{po.schoolName}</td>
          <td>{po.educatorEmail}</td>
          <td>{po.studentTier}</td>
          <td>${po.price}</td>
          <td>
            <a href={po.poFileUrl} target="_blank" rel="noreferrer">
              View PO
            </a>
          </td>
          <td>
            <button onClick={() => approvePO(po)}>
              Approve & Mark Paid
            </button>
          </td>
        </tr>
      ))}
  </tbody>
</table>


      <button onClick={() => navigate("/admin/roles")} style={styles.addButton}>
        Add New User
      </button>

      <button
  style={{ ...styles.deleteButton, marginBottom: 20 }}
  onClick={handleBulkDelete}
  disabled={selectedUserIds.length === 0}
>
  Delete Selected Users ({selectedUserIds.length})
</button>

<button
  style={{
    ...styles.addButton,
    backgroundColor: "#16a34a",
  }}
  onClick={handleBulkRestoreAccess}
  disabled={selectedUserIds.length === 0}
>
  Restore Access ({selectedUserIds.length})
</button>

<button
  style={{ ...styles.addButton, backgroundColor: "#7c3aed" }}
  onClick={() => setSchoolPlanFor({ uids: [...selectedUserIds], current: null, label: `${selectedUserIds.length} selected account${selectedUserIds.length === 1 ? "" : "s"}` })}
  disabled={selectedUserIds.length === 0}
  title="Schools and districts paying by invoice / purchase order"
>
  🏫 School plan ({selectedUserIds.length})
</button>


{/* 🔍 Search + Export */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 15,
    flexWrap: "wrap",
  }}
>
  <input
    type="text"
    placeholder="Search name, school, district, email, educator code…"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      padding: "10px 16px",
      borderRadius: 999,
      border: "1px solid #cfe0ec",
      width: 340,
      maxWidth: "100%",
      fontSize: 14,
    }}
  />
  {searchTerm && (
    <span style={{ fontSize: 13, color: "#6b7280" }}>
      {filteredUsers.length} of {users.length} users
    </span>
  )}

  <button
    onClick={exportUsersToExcel}
    style={{
      padding: "8px 14px",
      background: "#059669",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      cursor: "pointer",
      fontWeight: 600,
    }}
  >
    Export to Excel
  </button>
</div>

      <style>{`
        .admin-users-table tbody tr:nth-child(even) td {
          background-color: #f8fafc;
        }
        .admin-users-table tbody tr:hover td {
          background-color: #eaf2fb;
        }
      `}</style>
      <div style={styles.tableContainer}>
        {users.length > 0 ? (
          <table className="admin-users-table" style={styles.table}>
            <thead>
            <tr>
            <th style={styles.th}>Select</th>
  <th style={styles.th}></th> {/* Expand/Collapse Button */}
  <th style={styles.th}>First Name <SortBtn colKey="firstName" /></th>
  <th style={styles.th}>Last Name <SortBtn colKey="lastName" /></th>
  <th style={styles.th}>School Name <SortBtn colKey="schoolName" /></th>
  <th style={styles.th}>School District <SortBtn colKey="schoolDistrict" /></th>
  <th style={styles.th}>State <SortBtn colKey="state" /></th>
  <th style={styles.th}>Grade <SortBtn colKey="grade" /></th>
  <th style={styles.th}>View <SortBtn colKey="view" /></th>
  <th style={styles.th}>Role <SortBtn colKey="role" /></th>
  <th style={styles.th}>Status</th>
  <th style={styles.th}>Educator Code <SortBtn colKey="educatorCode" /></th>
  <th style={styles.th}>Email <SortBtn colKey="email" /></th>
  <th style={styles.th}>Dashboard Visits <SortBtn colKey="dashboardVisits" /></th>
  <th style={styles.th}>Trial Ends</th>
  <th style={styles.th}>Actions</th>
  <th style={styles.th}>UID <SortBtn colKey="id" /></th>
</tr>

            </thead>
            <tbody>
            {(() => {
  // Group users by educatorCode
  const grouped = filteredUsers.reduce((acc, user) => {
    const code = user.educatorCode || "none";
    if (!acc[code]) acc[code] = [];
    acc[code].push(user);
    return acc;
  }, {});

  // Get educator keys and sort their groups
  const educatorKeys = Object.keys(grouped);

  // Sort educator groups according to current sortConfig
  const sortedKeys = educatorKeys.sort((a, b) => {
    const firstA = grouped[a][0];
    const firstB = grouped[b][0];

    const valA =
      sortConfig.key === "dashboardVisits"
        ? (dashboardCounts[firstA.id] ?? 0)
        : getSortableValue(firstA, sortConfig.key);

    const valB =
      sortConfig.key === "dashboardVisits"
        ? (dashboardCounts[firstB.id] ?? 0)
        : getSortableValue(firstB, sortConfig.key);

    const dir = sortConfig.dir === "asc" ? 1 : -1;

    if (valA < valB) return -1 * dir;
    if (valA > valB) return 1 * dir;
    return 0;
  });

  // Now render sorted groups
  return sortedKeys.map((educatorCode) => {
    const group = grouped[educatorCode];
    const educators = group.filter((u) =>
      (u.role || "").toLowerCase().includes("educator")
    );
    const students = group
      .filter((u) => (u.role || "").toLowerCase().includes("student"))
      .sort((a, b) => (a.firstName || "").localeCompare(b.firstName || ""));

    const mainRow = educators.length > 0 ? educators[0] : group[0];
    const isExpanded = expandedEducator === educatorCode;

    return (
      <React.Fragment key={educatorCode}>
        {/* Educator row */}
        <tr
  key={mainRow.id}
  style={{
    background: newVisitUserIds.includes(mainRow.id)
      ? "#fff8dc" // yellow highlight
      : isExpanded
      ? "#dbeafe"
      : "#f9fafb",
    transition: "background 0.3s ease",
  }}
>

<td style={styles.td}>
  <input
    type="checkbox"
    checked={selectedUserIds.includes(mainRow.id)}
    onChange={() => toggleSelectUser(mainRow.id)}
  />
</td>

          <td style={styles.td}>
            <button
              onClick={() =>
                setExpandedEducator(isExpanded ? null : educatorCode)
              }
              style={{
                ...styles.expandButton,
                background: isExpanded ? "#2563eb" : "#fff",
                color: isExpanded ? "#fff" : "#000",
              }}
            >
              {isExpanded ? "Hide Students" : "Show Students"}
            </button>
          </td>
          <td style={styles.td}>{mainRow.firstName || ""}</td>
          <td style={styles.td}>{mainRow.lastName || ""}</td>
          <td style={styles.td}>{mainRow.schoolName || ""}</td>
          <td style={styles.td}>{mainRow.schoolDistrict || ""}</td>
          <td style={styles.td}>{mainRow.state || ""}</td>
          <td style={styles.td}>{mainRow.grade || ""}</td>
          <td style={styles.td}>{mainRow.view || ""}</td>
          <td style={styles.td}>{mainRow.role || ""}</td>
          <td style={styles.td}>
  {renderStatusBadge(mainRow)}
</td>
          <td style={styles.td}>{mainRow.educatorCode || ""}</td>
          <td style={styles.td}>{mainRow.email || ""}</td>
          <td style={styles.td}>{dashboardCounts[mainRow.id] ?? 0}</td>
          <td style={styles.td}>
  {formatTrialEnd(mainRow)}
</td>

          <td style={styles.td}>
            <button
              onClick={() => {
                setShowDetails(mainRow);
                setLogs([]);
                setLogsCursor(null);
                loadLogs(mainRow.id);
              }}
              style={styles.detailsButton}
            >
              Details
            </button>
            <button
  onClick={() => handlePause(mainRow.id)}
  style={{
    ...styles.pauseButton,
    backgroundColor:
      mainRow?.trial?.status === "paused"
        ? "#16a34a"
        : "#f59e0b",
  }}
>
  {getAccessActionLabel(mainRow)}
</button>
<button type="button" onClick={() => setTrialStatus(mainRow.id, "active")} style={styles.viewsButton}>
  Activate
</button>
<button type="button" onClick={() => setTrialStatus(mainRow.id, "paused")} style={styles.viewsButton}>
  Pause
</button>
<button type="button" onClick={() => setTrialStatus(mainRow.id, "expired")} style={styles.viewsButton}>
  Expire
</button>


            <button
              onClick={() => openViewsModalForUser(db, mainRow)}
              style={styles.viewsButton}
            >
              Views
            </button>
            <button
              onClick={() => handleDelete(mainRow.id)}
              style={styles.deleteButton}
            >
              Delete
            </button>
          </td>
          <td style={styles.td}>{mainRow.id}</td>
        </tr>

        {/* Students under this educator */}
        {isExpanded &&
  students.map((s) => (
    <tr
    key={s.id}
    style={{
      background: newVisitUserIds.includes(mainRow.id)
        ? "#fff8dc" // yellow highlight
        : isExpanded
        ? "#dbeafe"
        : "#f9fafb",
      transition: "background 0.3s ease",
    }}
  >
  
  <td style={styles.td}>
  <input
    type="checkbox"
    checked={selectedUserIds.includes(s.id)}
    onChange={() => toggleSelectUser(s.id)}
  />
</td>

              <td style={styles.td}></td>
              <td style={styles.td}>
  {renderStatusBadge(mainRow)}
</td>
              <td style={styles.td}>{s.firstName || ""}</td>
              <td style={styles.td}>{s.lastName || ""}</td>
              <td style={styles.td}>{s.schoolName || ""}</td>
              <td style={styles.td}>{s.schoolDistrict || ""}</td>
              <td style={styles.td}>{s.state || ""}</td>
              <td style={styles.td}>{s.grade || ""}</td>
              <td style={styles.td}>{s.view || ""}</td>
              <td style={styles.td}>{s.role || ""}</td>
              <td style={styles.td}>{s.educatorCode || ""}</td>
              <td style={styles.td}>{s.email || ""}</td>
              <td style={styles.td}>{dashboardCounts[s.id] ?? 0}</td>
              <td style={styles.td}>
  {formatTrialEnd(s)}
</td>

              <td style={styles.td}>
                <button
                  onClick={() => {
                    setShowDetails(s);
                    setLogs([]);
                    setLogsCursor(null);
                    loadLogs(s.id);
                  }}
                  style={styles.detailsButton}
                >
                  Details
                </button>
                <button
  onClick={() => handlePause(mainRow.id)}
  style={{
    ...styles.pauseButton,
    backgroundColor:
      mainRow?.trial?.status === "paused"
        ? "#16a34a"
        : "#f59e0b",
  }}
>
  {getAccessActionLabel(mainRow)}
</button>


                <button
                  onClick={() => openViewsModalForUser(db, s)}
                  style={styles.viewsButton}
                >
                  Views
                </button>
                <button
                  onClick={() => handleDelete(s.id)}
                  style={styles.deleteButton}
                >
                  Delete
                </button>
              </td>
              <td style={styles.td}>{s.id}</td>
            </tr>
          ))}
      </React.Fragment>
    );
  });
})()}


</tbody>

          </table>
        ) : <p>No users found.</p>}
      </div>

      {showEmailModal && (
  <div style={modalStyles.backdrop}>
    <div style={modalStyles.modal}>
      <h2 style={{ marginTop: 0 }}>Send Email</h2>

      <div style={{ marginBottom: 10 }}>
        <strong>Recipients:</strong>{" "}
        {selectedUserIds.length} user(s)
      </div>

      <div style={{ marginBottom: 10 }}>
        <label>Subject</label>
        <input
          value={emailSubject}
          onChange={(e) => setEmailSubject(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
        />
      </div>

      <div style={{ marginBottom: 10 }}>
        <label>Message</label>
        <textarea
          rows={8}
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
            resize: "vertical",
          }}
        />
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <button
          onClick={async () => {
            if (!emailSubject || !emailBody) {
              alert("Subject and message are required.");
              return;
            }

            const recipients = users.filter((u) =>
              selectedUserIds.includes(u.id)
            );

            if (!recipients.length) return;

            const ok = window.confirm(
              `Send email to ${recipients.length} user(s)?`
            );
            if (!ok) return;

            setSendingEmail(true);

            try {
              for (const u of recipients) {
                if (!u.email) continue;

                await sendEmailViaGmail({
                  to: u.email,
                  subject: emailSubject,
                  body: emailBody,
                  templateId: "admin-manual",
                });
              }

              alert("Emails sent successfully.");
              setShowEmailModal(false);
              setEmailSubject("");
              setEmailBody("");
              setSelectedUserIds([]);
            } catch (err) {
              console.error("Email send failed", err);
              alert("One or more emails failed. Check logs.");
            } finally {
              setSendingEmail(false);
            }
          }}
          disabled={sendingEmail}
          style={{
            padding: "8px 14px",
            background: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {sendingEmail ? "Sending..." : "Send Email"}
        </button>

        <button
          onClick={() => setShowEmailModal(false)}
          style={{
            padding: "8px 14px",
            background: "#6b7280",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

      {schoolPlanFor && (
        <SchoolPlanEditor
          uids={schoolPlanFor.uids}
          current={schoolPlanFor.current}
          label={schoolPlanFor.label}
          onClose={() => setSchoolPlanFor(null)}
          onSaved={(uids, plan) => {
            const local = plan ? { ...plan, endDate: plan.endDate ? new Date(plan.endDate) : null } : null;
            setUsers((prev) => prev.map((u) => (uids.includes(u.id) ? { ...u, classPlan: local } : u)));
            setShowDetails((d) => (d && uids.includes(d.id) ? { ...d, classPlan: local } : d));
          }}
        />
      )}

      {/* Details Popup */}
      {showDetails && (
        <div style={modalStyles.backdrop}>
          <div style={modalStyles.modal}>
            <h2 style={{ marginTop: 0, textAlign: "center" }}>User Details</h2>

            {/* Profile fields */}
            <div style={modalStyles.grid}>
              <div style={modalStyles.field}><label style={modalStyles.label}>First Name:</label>{showDetails.firstName || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Last Name:</label>{showDetails.lastName || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Email:</label>{showDetails.email || ""}</div>
              {/* INSERT: School fields */}
<div style={modalStyles.field}>
  <label style={modalStyles.label}>School Name:</label>
  {showDetails.schoolName || ""}
</div>
<div style={modalStyles.field}>
  <label style={modalStyles.label}>School District:</label>
  {showDetails.schoolDistrict || ""}
</div>

              <div style={modalStyles.field}><label style={modalStyles.label}>State:</label>{showDetails.state || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Grade:</label>{showDetails.grade || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>View:</label>{showDetails.view || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Role:</label>{showDetails.role || ""}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Educator Code:</label>{showDetails.educatorCode || ""}</div>
              <div style={modalStyles.fieldFull}>
                <label style={modalStyles.label}>Notes:</label>
                <div>{showDetails.notes || ""}</div>
              </div>
              <div style={modalStyles.field}><label style={modalStyles.label}>Created:</label>{formatDateMaybe(showDetails.createdAt || showDetails.joinDate)}</div>
              <div style={modalStyles.field}><label style={modalStyles.label}>UID:</label>{showDetails.id}</div>
              <div style={modalStyles.fieldFull}>
                <label style={modalStyles.label}>🏫 School / District plan:</label>{" "}
                {schoolPlanSummary(showDetails.classPlan) || "none"}{" "}
                <button
                  type="button"
                  onClick={() =>
                    setSchoolPlanFor({
                      uids: [showDetails.id],
                      current: showDetails.classPlan || null,
                      label: `${showDetails.firstName || ""} ${showDetails.lastName || ""}`.trim() || showDetails.email,
                    })
                  }
                  style={{ marginLeft: 6, border: 0, borderRadius: 8, padding: "4px 10px", background: "#ede9fe", color: "#5b21b6", fontWeight: 700, cursor: "pointer" }}
                >
                  {showDetails.classPlan ? "Edit" : "Set plan"}
                </button>
              </div>
            </div>

            {/* Accessible Pages */}
            <h3 style={{ marginTop: 18 }}>Accessible Pages</h3>
            <div style={{ ...modalStyles.fieldFull, marginTop: 8 }}>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {getAccessiblePagesForUser(showDetails).map(p => (
                  <li key={p.path}>
                    <code>{p.path}</code> — {p.label || ""}
                  </li>
                ))}
              </ul>
            </div>

{/* Trial Settings */}
            <h3 style={{ marginTop: 20 }}>Trial Settings</h3>

<div style={{ display: "flex", gap: 12, alignItems: "center" }}>
  <label>Trial Ends:</label>

  <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
  <label>Trial Ends:</label>

  <input
    type="date"
    value={trialDraftDate}
    onChange={(e) => setTrialDraftDate(e.target.value)}
    style={{
      padding: "6px 10px",
      borderRadius: 6,
      border: "1px solid #ccc",
    }}
  />

<button
  type="button"
  onClick={async () => {
    if (!trialDraftDate) return alert("Please pick a date first.");

    const newDate = new Date(trialDraftDate);
    const now = new Date();
    const isFuture = newDate > now;

    await updateDoc(doc(db, "users", showDetails.id), {
      "trial.endDate": newDate,
      "trial.status": isFuture ? "active" : "expired",
      "trial.updatedAt": serverTimestamp(),
    });

    // update table
    setUsers((prev) =>
      prev.map((u) =>
        u.id === showDetails.id
          ? {
              ...u,
              trial: {
                ...(u.trial || {}),
                endDate: newDate,
                status: isFuture ? "active" : "expired",
              },
            }
          : u
      )
    );

    // update open modal
    setShowDetails((prev) =>
      prev
        ? {
            ...prev,
            trial: {
              ...(prev.trial || {}),
              endDate: newDate,
              status: isFuture ? "active" : "expired",
            },
          }
        : prev
    );
  }}
  style={{
    padding: "6px 10px",
    borderRadius: 6,
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600,
  }}
>
  Save Date
</button>

  <div style={{ display: "flex", gap: 8 }}>
    <button type="button" onClick={() => setTrialStatus(showDetails.id, "active")}>
      Activate
    </button>

    <button type="button" onClick={() => setTrialStatus(showDetails.id, "paused")}>
      Pause
    </button>

    <button type="button" onClick={() => setTrialStatus(showDetails.id, "expired")}>
      Expire
    </button>
  </div>
</div>


</div>

            {/* Access History */}
            <h3 style={{ marginTop: 18 }}>Access History (most recent)</h3>
            <div style={modalStyles.fieldFull}>
              {logsLoading && logs.length === 0 ? (
                <div>Loading…</div>
              ) : logs.length === 0 ? (
                <div>No page views logged yet.</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="excel-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={styles.th}>When</th>
                        <th style={styles.th}>Path</th>
                        <th style={styles.th}>Title</th>
                        <th style={styles.th}>Referrer</th>
                        <th style={styles.th}>Device</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map((r) => (
                        <tr key={r.id} style={styles.row}>
                          <td style={styles.td}>{formatDateMaybe(r.ts)}</td>
                          <td style={styles.td}><code>{r.path}</code></td>
                          <td style={styles.td}>{r.title || ""}</td>
                          <td style={styles.td} title={r.referrer || ""}>{(r.referrer || "").slice(0, 40)}</td>
                          <td style={styles.td} title={r.device || ""}>{(r.device || "").slice(0, 40)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {logsCursor && (
                    <div style={{ marginTop: 10, textAlign: "center" }}>
                      <button
                        onClick={() => loadLogs(showDetails.id, logsCursor)}
                        style={styles.addButton}
                        disabled={logsLoading}
                      >
                        {logsLoading ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div style={modalStyles.actions}>
              <button onClick={() => setShowDetails(null)} style={styles.returnButton}>Close</button>
            </div>
          </div>
        </div>
      )}
{/* Views Modal */}
{showViewsFor && (
  <div style={modalStyles.backdrop}>
    <div style={modalStyles.modal}>
      <h2 style={{ marginTop: 0, textAlign: "center" }}>
        Page Views — {showViewsFor.firstName || ""} {showViewsFor.lastName || ""} <small>({showViewsFor.id})</small>
      </h2>

      {/* Expected pages for this user's role */}
      <div style={{ margin: "10px 0", padding: 12, border: "1px solid #eee", borderRadius: 8, background: "#fafafa" }}>
        <strong>Expected pages for role:</strong> {showViewsFor.role || "—"}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
        {expectedPathsForRole(showViewsFor.role).length === 0 ? (
            <span style={{ fontStyle: "italic" }}>N/A</span>
          ) : (
            expectedPathsForRole(showViewsFor.role).map((p) => (
                   <span key={p} style={{ padding: "4px 8px", borderRadius: 999, border: "1px solid #ddd", fontSize: 12 }}>
                     {p}
                   </span>
            ))
          )}
        </div>
      </div>

      {/* Summary table */}
      <h3>Summary by Page</h3>
      {viewsLoading ? (
        <div>Loading…</div>
      ) : pageSummary.length === 0 ? (
        <div>No page views found for this user.</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Path</th>
                <th style={styles.th}>Visits</th>
                <th style={styles.th}>Last Seen</th>
              </tr>
            </thead>
            <tbody>
              {pageSummary.map((s) => (
                <tr key={s.path} style={styles.row}>
                  <td style={styles.td}><code>{s.path}</code></td>
                  <td style={styles.td}>{s.count}</td>
                  <td style={styles.td}>{formatDateMaybe(s.lastTs)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Recent hits */}
      {!viewsLoading && pageHits.length > 0 && (
        <>
          <h3 style={{ marginTop: 18 }}>Recent Hits</h3>
          <div style={{ maxHeight: 260, overflow: "auto", border: "1px solid #eee", borderRadius: 8 }}>
            <table style={{ ...styles.table, width: "100%" }}>
              <thead>
                <tr>
                  <th style={styles.th}>When</th>
                  <th style={styles.th}>Path</th>
                  <th style={styles.th}>Title</th>
                  <th style={styles.th}>Referrer</th>
                  <th style={styles.th}>Device</th>
                </tr>
              </thead>
              <tbody>
                {pageHits.map((h) => (
                  <tr key={h.id} style={styles.row}>
                    <td style={styles.td}>{formatDateMaybe(h.ts)}</td>
                    <td style={styles.td}><code>{h.path}</code></td>
                    <td style={styles.td}>{h.title}</td>
                    <td style={styles.td}>{h.referrer}</td>
                    <td style={styles.td}>{h.device}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <div style={{ marginTop: 16, textAlign: "center" }}>
        <button onClick={() => { setShowViewsFor(null); setPageHits([]); setPageSummary([]); }} style={styles.returnButton}>
          Close
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

const styles = {
  returnButton: {
    marginBottom: "20px",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
    fontSize: "16px",
  },
  addButton: {
    margin: "10px",
    padding: "10px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  tableContainer: { marginTop: "20px", overflowX: "auto", maxHeight: "70vh", overflowY: "auto" },
  table: {
    margin: "0 auto",
    borderCollapse: "collapse",
    width: "95%",
    border: "1px solid #ccc",
  },
  th: {
    border: "1px solid #ccc",
    padding: "10px 12px",
    backgroundColor: "#eef2f7",
    textAlign: "left",
    fontSize: "13px",
    fontWeight: 700,
    color: "#1f2937",
    position: "sticky",
    top: 0,
    zIndex: 1,
    whiteSpace: "nowrap",
  },
  td: {
    border: "1px solid #e5e9ef",
    padding: "8px 12px",
    textAlign: "left",
    fontSize: "13px",
    color: "#1f2937",
  },
  row: {
    border: "1px solid #ccc",
  },
  
  detailsButton: {
    marginRight: "5px",
    padding: "5px 10px",
    backgroundColor: "#4a90e2",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },

  viewsButton: {
      marginRight: "5px",
       padding: "5px 10px",
       backgroundColor: "#6f42c1",
       color: "#fff",
       border: "none",
       borderRadius: "5px",
       cursor: "pointer",
       boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
     },

  pauseButton: {
    marginRight: "5px",
    padding: "5px 10px",
    backgroundColor: "#ffc107",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  deleteButton: {
    padding: "5px 10px",
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
};

const modalStyles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    width: "min(900px, 95vw)",
    maxHeight: "85vh",
    overflow: "auto",
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    textAlign: "left",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "12px",
  },
  field: {
    background: "#fafafa",
    border: "1px solid #eee",
    borderRadius: "8px",
    padding: "10px",
  },
  fieldFull: {
    gridColumn: "1 / -1",
    background: "#fafafa",
    border: "1px solid #eee",
    borderRadius: "8px",
    padding: "10px",
  },
  label: {
    display: "block",
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px",
  },
  actions: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },
  rowHover: {
    transition: "background 0.2s ease",
    cursor: "pointer",
  },
  expandButton: {
    border: "1px solid #ccc",
    borderRadius: "5px",
    background: "#fff",
    cursor: "pointer",
    padding: "6px 10px",
    fontWeight: 500,
    transition: "all 0.3s ease",
  },
  
};

export default AdminUsers;
